var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-container body-container" },
    [
      _c(
        "div",
        { staticClass: "body-header" },
        [
          _c("el-page-header", {
            attrs: { content: "个人中心" },
            on: { back: _vm.goBack },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "user-main" },
        [
          _c(
            "el-tabs",
            { attrs: { "tab-position": "left" } },
            [
              _c("el-tab-pane", { attrs: { label: "个人信息" } }, [
                _c(
                  "div",
                  { staticClass: "user-box" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "userInfoForm",
                        staticClass: "form-container",
                        attrs: { model: _vm.userInfo },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "postInfo-container-item",
                            attrs: {
                              "label-width": "100px",
                              label: "用户id：",
                            },
                          },
                          [
                            _c("div", [
                              _vm._v(_vm._s(_vm.userInfo.developer_uid)),
                            ]),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "postInfo-container-item",
                            attrs: { "label-width": "100px", label: "昵称：" },
                          },
                          [
                            _c("span", { staticClass: "nickname" }, [
                              _vm._v(_vm._s(_vm.userInfo.nickname)),
                            ]),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "postInfo-container-item",
                            attrs: { "label-width": "100px", label: "VIP：" },
                          },
                          [
                            _c("span", { staticClass: "vip" }, [
                              _vm._v(_vm._s(_vm.vipLevel)),
                            ]),
                            !_vm.isVip
                              ? _c("span", [_vm._v("(已失效)")])
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "postInfo-container-item",
                            attrs: { "label-width": "100px", label: "邮箱：" },
                          },
                          [
                            _vm.userInfo.email
                              ? _c("span", { staticClass: "email" }, [
                                  _vm._v(_vm._s(_vm.userInfo.email)),
                                ])
                              : _vm._e(),
                            _vm.userInfo.email
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bind-email-btn text-btn",
                                    on: { click: _vm.showBindEmail },
                                  },
                                  [_vm._v("修改邮箱")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "bind-email-btn text-btn",
                                    on: { click: _vm.showBindEmail },
                                  },
                                  [_vm._v("绑定邮箱")]
                                ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.userInfo.email ? "修改邮箱" : "绑定邮箱",
            visible: _vm.dialogBind,
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogBind = $event
            },
            close: _vm.hiddenBindEmail,
          },
        },
        [
          _c(
            "div",
            { staticClass: "clearfix" },
            [
              _c(
                "el-form",
                {
                  ref: "bindForm",
                  staticClass: "form-container",
                  attrs: { model: _vm.dialogData },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "postInfo-container-item",
                      attrs: {
                        "label-width": "100px",
                        label: "邮箱:",
                        rules: _vm.userInfoRule.email,
                        prop: "email",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        staticStyle: { width: "270px" },
                        attrs: { placeholder: "请输入邮箱" },
                        model: {
                          value: _vm.dialogData.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogData, "email", $$v)
                          },
                          expression: "dialogData.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "postInfo-container-item",
                      attrs: {
                        "label-width": "100px",
                        label: "验证码:",
                        rules: _vm.userInfoRule.code,
                        prop: "code",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        staticStyle: { width: "270px" },
                        attrs: { placeholder: "邮箱验证码" },
                        model: {
                          value: _vm.dialogData.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogData, "code", $$v)
                          },
                          expression: "dialogData.code",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "send-code-btn",
                          class: { disabled: _vm.sendCodeLoading },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.sendCode($event)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.codeBtnText))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "default" },
                          on: { click: _vm.hiddenBindEmail },
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.bindEmail },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }